module.exports = __webpack_public_path__ + "img/30836ea.png";